import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface TransactionListOcpiSessionIdCellProps
  extends CellContext<TransactionModel, TransactionModel['ocpiSessionId']> {}

export const TransactionListOcpiSessionIdCell = (
  props: TransactionListOcpiSessionIdCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row, getValue } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() =>
        navigate(
          generatePath(APP_PATH.TRANSACTION.DETAILS, { id: row.original.id }),
        )
      }
      fullWidth>
      <Text truncate>{getValue()?.substring(0, 8)}</Text>
    </Link>
  );
};
